"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _checkmark = _interopRequireDefault(require("../../assets/checkmark.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckBox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      children = _ref.children,
      name = _ref.name,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["className", "checked", "disabled", "onChange", "children", "name", "theme"]);

  var _useState = (0, _react.useState)(checked ? true : false),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];

  var handleChange = function handleChange(e) {
    if (!disabled) {
      e.persist();
      setIsChecked(e.currentTarget.checked);
      onChange({
        name: e.target.name,
        value: e.target.value
      });
    }
  };

  (0, _react.useEffect)(function () {
    if (isChecked !== checked) {
      setIsChecked(checked);
    }
  }, [checked]);
  return /*#__PURE__*/_react.default.createElement(StyledLabel, _extends({
    htmlFor: name,
    disabled: disabled,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement("input", {
    ref: ref,
    name: name,
    id: name,
    disabled: disabled,
    checked: isChecked,
    type: "checkbox",
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }), /*#__PURE__*/_react.default.createElement(StyledBox, {
    disabled: disabled,
    checked: isChecked
  }, isChecked && disabled ? /*#__PURE__*/_react.default.createElement(StyledCheckmark, {
    color: theme.ui.disabled
  }) : isChecked && !disabled ? /*#__PURE__*/_react.default.createElement(StyledCheckmark, {
    color: 'white'
  }) : null), children);
});

var StyledBox = _styledComponents.default.div.withConfig({
  displayName: "StyledBox"
})(["background-color:", ";width:1.9rem;height:1.9rem;border:", ";box-sizing:border-box;border-radius:0.3rem;margin-right:1rem;transition:0.2s;display:flex;justify-content:center;align-items:center;&:hover{background-color:", ";}"], function (_ref2) {
  var theme = _ref2.theme,
      checked = _ref2.checked,
      disabled = _ref2.disabled;
  return checked && !disabled ? theme.brand.primary : '#F0F1F3';
}, function (props) {
  return props.checked && !props.disabled ? null : props.disabled ? '0.1rem solid #CCCCCC' : '0.1rem solid #A29C95';
}, function (props) {
  return props.checked ? null : '#F7F8F9';
});

var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "StyledLabel"
})(["font-family:", ";font-size:1.4rem;line-height:120%;display:flex;align-items:center;color:", ";cursor:", ";& input{display:none;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, function (_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled ? theme.ui.disabled : theme.typo.text;
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? '' : 'pointer';
});

var StyledCheckmark = (0, _styledComponents.default)(_checkmark.default).withConfig({
  displayName: "StyledCheckmark"
})(["width:80%;"]);
CheckBox.displayName = 'CheckBox';
CheckBox.defaultProps = {
  checked: false,
  disabled: false,
  otherProps: {}
};
CheckBox.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** If true box is disabled */
  disabled: _propTypes.bool,

  /** If true box is initialy checked */
  checked: _propTypes.bool,

  /** The label next to the box */
  children: _propTypes.node,

  /** Triggered when button is clicked */
  onChange: _propTypes.func,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  name: _propTypes.string,
  theme: _propTypes.object
};

var _default = (0, _styledComponents.withTheme)(CheckBox);

exports.default = _default;